import { Route, Routes } from 'react-router-dom';

import AboutUsPage from 'pages/about-us';
import CreditCardPage from 'pages/credit-card/index';
import CreditCardRequestFormPage from 'pages/credit-card/form/index';
import CreditRequestBasicPage from 'pages/credit-request/basic/index';
import CreditRequestDocumentationPage from 'pages/credit-request/documentation';
import CreditRequestExistsPage from 'pages/credit-request/exists';
import CreditRequestFormPage from 'pages/credit-request/form/request/index';
import CreditRequestLayout from 'pages/credit-request/layout';
import CreditRequestOverviewPage from 'pages/credit-request/form/overview';
import CreditRequestVerifyPage from 'pages/public/credit';
import FaqPage from 'pages/faq-page';
import HomePage from 'pages/home';
import MobileAppPage from 'pages/mobile-app';
import Error406Page from 'pages/error/406';
import Error500Page from 'pages/error/500';
import Error503Page from 'pages/error/503';
import MaintenancePage from 'pages/error/maintenance';
import { Layout } from 'components';
import { RouteConstants } from '../../constants';
import Error404Page from 'pages/error/404';
import CardRequestVerifyPage from 'pages/public/card';
import { ROUTE_PRIVACY_POLICY, ROUTE_TERMS_OF_USE, ROUTE_IMPRESSUM, ROUTE_DOWNLOAD } from 'constants/route';
import PrivacyPolicyPage from 'pages/privacy-and-policy';
import TermsPage from 'pages/terms-of-use';
import ImpressumPage from 'pages/impressum';
import DownloadPage from 'pages/download';

const {
  ROUTE_ABOUT_US,
  ROUTE_CREDIT_CARD,
  ROUTE_CREDIT_CARD_FORM,
  ROUTE_CREDIT_CARD_REQUEST_VERIFY,
  ROUTE_CREDIT_REQUEST,
  ROUTE_CREDIT_REQUEST_BASIC_SHORT,
  ROUTE_CREDIT_REQUEST_FORM_SHORT,
  ROUTE_CREDIT_REQUEST_EXISTS_SHORT,
  ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT,
  ROUTE_CREDIT_REQUEST_OVERVIEW,
  ROUTE_CREDIT_REQUEST_VERIFY,
  ROUTE_ERROR_406,
  ROUTE_ERROR_500,
  ROUTE_ERROR_503,
  ROUTE_FAQ,
  ROUTE_HOME,
  ROUTE_LANDING,
  ROUTE_MOBILE_APP,
} = RouteConstants;

const CustomRouter = () => {
  return (
    <Routes>
      {/* <Route path={ROUTE_LANDING} element={<MaintenancePage />} /> */}
      <Route element={<Layout />}>
        <Route path={ROUTE_HOME} element={<HomePage />} />
        <Route path={ROUTE_ABOUT_US} element={<AboutUsPage />} />
        <Route path={ROUTE_FAQ} element={<FaqPage />} />
        <Route path={ROUTE_CREDIT_CARD} element={<CreditCardPage />} />
        <Route path={ROUTE_CREDIT_CARD_FORM} element={<CreditCardRequestFormPage />} />
        <Route path={ROUTE_MOBILE_APP} element={<MobileAppPage />} />
        <Route path={ROUTE_PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
        <Route path={ROUTE_TERMS_OF_USE} element={<TermsPage />} />
        <Route path={ROUTE_IMPRESSUM} element={<ImpressumPage />} />

        <Route path={ROUTE_CREDIT_REQUEST} element={<CreditRequestLayout />}>
          <Route path={ROUTE_CREDIT_REQUEST_BASIC_SHORT} element={<CreditRequestBasicPage />} />
          <Route path={ROUTE_CREDIT_REQUEST_FORM_SHORT} element={<CreditRequestFormPage />} />
          <Route path={ROUTE_CREDIT_REQUEST_EXISTS_SHORT} element={<CreditRequestExistsPage />} />
          <Route path={ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT} element={<CreditRequestDocumentationPage />} />
          <Route path={ROUTE_CREDIT_REQUEST_OVERVIEW} element={<CreditRequestOverviewPage />} />
          <Route path={ROUTE_CREDIT_REQUEST + '/:id'} element={<CreditRequestOverviewPage />} />
        </Route>

        <Route path={`${ROUTE_CREDIT_REQUEST_VERIFY}/:id`} element={<CreditRequestVerifyPage />} />
        <Route path={`${ROUTE_CREDIT_CARD_REQUEST_VERIFY}/:id`} element={<CardRequestVerifyPage />} />
      </Route>
      <Route path={ROUTE_DOWNLOAD} element={<DownloadPage />} />
      <Route path={ROUTE_ERROR_406} element={<Error406Page />} />
      <Route path={ROUTE_ERROR_500} element={<Error500Page />} />
      <Route path={ROUTE_ERROR_503} element={<Error503Page />} />
      <Route path='*' element={<Error404Page />} />
    </Routes>
  )
}

export default CustomRouter;